import { render, staticRenderFns } from "./OxygenVideoInput.vue?vue&type=template&id=9ebe081c&scoped=true&"
import script from "./OxygenVideoInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenVideoInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebe081c",
  null
  
)

export default component.exports